import PersonaOfficeShell from "@/components/PersonaOfficeShell";
import { Send, Film, Globe, IdCard, TrendingUp, Users, Search, Heart } from "lucide-react";

/**
 * L13 · Distributor dashboard.
 * Phase 1: pure listing + discovery.
 * Phase 2 (roadmap): slate manager, deals ledger with exhibitors,
 * box-office roll-up back to the producer.
 */
const CONFIG = {
  layer:           "L13",
  label:           "Distributor",
  testidPrefix:    "distributor-office",
  accent:          "#0F766E",
  Icon:            Send,
  expectedOrgType: "distributor",
  blurb:           "Move films from producer to audience — theatrical, OTT, TV, overseas. Discover exhibitors and manage your slate.",
  tiles: [
    {
      key: "slate", to: "/distributor/slate", TileIcon: Film,
      title: "Sales Catalogue",
      desc:  "Every film you distribute — territories, windows, delivery status.",
      chip: "Live", chipTone: "live",
    },
    {
      key: "interests", to: "/distributor/interests", TileIcon: Heart,
      title: "Interest Signals",
      desc:  "Live \"want to book\" signals from exhibitors — work each lead new → contacted → booked.",
      chip: "Live", chipTone: "live",
    },
    {
      key: "exhibitors", to: "/directory/orgs?type=exhibitor", TileIcon: Users,
      title: "Exhibitor Directory",
      desc:  "Multiplex chains, single-screens and drive-ins — where your slate can play.",
      chip: "Live", chipTone: "live",
    },
    {
      key: "producers", to: "/directory/orgs?type=production_house", TileIcon: Search,
      title: "Production Houses",
      desc:  "Every verified producer on Call·Sheet — pitch acquisitions early.",
      chip: "Live", chipTone: "live",
    },
    {
      key: "deals", TileIcon: TrendingUp,
      title: "Deals & Settlements",
      desc:  "Track distributor-exhibitor deal terms, splits and box-office settlements.",
      chip: "Soon", chipTone: "soon",
    },
    {
      key: "public-profile", to: "/office/public-profile", TileIcon: Globe,
      title: "Public Profile",
      desc:  "Your distribution house — territory reach, past releases.",
      chip: "Live", chipTone: "live",
    },
    {
      key: "icard", to: "/icard", TileIcon: IdCard,
      title: "Owner iCard",
      desc:  "Your verified, co-branded identity card.",
      chip: "Live", chipTone: "live",
    },
  ],
};

export default function DistributorDashboard() {
  return <PersonaOfficeShell config={CONFIG} />;
}
